module.exports = __webpack_public_path__ + "img/602x698 About Us.439bf5b5.jpg";